import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  name: "form",
  novalidate: ""
};
const _hoisted_2 = {
  class: "block-content pt-4 pr-4"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "p-4"
};
const _hoisted_5 = {
  key: 0,
  class: "block-content",
  style: {
    "padding-bottom": "65px"
  }
};
const _hoisted_6 = {
  class: "ng-binding"
};
const _hoisted_7 = {
  class: "ng-binding"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  class: "py-2",
  "data-cy": "client-matter-search"
};
const _hoisted_10 = {
  key: 0,
  class: "pt-2"
};
const _hoisted_11 = {
  class: ""
};
const _hoisted_12 = {
  class: "flex py-2"
};
const _hoisted_13 = {
  class: "w-9/12"
};
const _hoisted_14 = {
  class: "text-yellow-600"
};
const _hoisted_15 = {
  key: 1,
  class: "text-yellow-600",
  "data-cy": "trust-deposit-qbo-warning"
};
const _hoisted_16 = {
  class: "py-2"
};
const _hoisted_17 = {
  id: "payment-method",
  class: "flex"
};
const _hoisted_18 = {
  class: "w-9/12"
};
const _hoisted_19 = {
  class: "flex items-center py-2"
};
const _hoisted_20 = {
  class: "w-4/12"
};
const _hoisted_21 = {
  class: "w-3/12"
};
const _hoisted_22 = ["value"];
const _hoisted_23 = {
  class: "flex py-2"
};
const _hoisted_24 = {
  class: "w-3/12"
};
const _hoisted_25 = {
  class: "py-2"
};
const _hoisted_26 = {
  class: "w-9/12"
};
const _hoisted_27 = {
  class: "flex my-2"
};
const _hoisted_28 = {
  class: "w-9/12"
};
const _hoisted_29 = {
  class: "flex my-2"
};
const _hoisted_30 = {
  class: "w-9/12"
};
const _hoisted_31 = {
  class: "flex justify-between pt-8"
};
const _hoisted_32 = {
  class: "fa fa-cog fa-spin",
  style: {
    "margin-left": "5px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ClientMatterSearch = _resolveComponent("ClientMatterSearch");
  const _component_ll_select = _resolveComponent("ll-select");
  const _component_ll_date_picker = _resolveComponent("ll-date-picker");
  const _component_LlTooltip = _resolveComponent("LlTooltip");
  const _component_LlSecondaryButton = _resolveComponent("LlSecondaryButton");
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "ts modal-wrapper vue-modal-background",
    style: {
      "z-index": "100"
    },
    onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["prevent"]))
  }, [_createElementVNode("div", {
    class: "ts modal",
    onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"])),
    style: {
      "width": "650px"
    }
  }, [_createElementVNode("form", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(), _createElementBlock("svg", {
    onClick: _cache[0] || (_cache[0] = $event => $options.cancel()),
    width: "14",
    height: "14",
    class: "close-btn float-right cursor-pointer",
    viewBox: "0 0 16 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  }, [...(_cache[14] || (_cache[14] = [_createElementVNode("g", {
    transform: "translate(2.000000, 2.000000)",
    stroke: "#727272"
  }, [_createElementVNode("path", {
    d: "M0.24,0.24 L11.76,11.76",
    "stroke-width": "2"
  }), _createElementVNode("path", {
    d: "M0.24,0.24 L11.76,11.76",
    "stroke-width": "2",
    transform: "translate(6.000000, 6.000000) scale(-1, 1) translate(-6.000000, -6.000000) "
  })], -1)]))])), !$data.loading ? (_openBlock(), _createElementBlock("h1", _hoisted_3, "Record Deposit to Trust Account")) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("h4", _hoisted_4, [...(_cache[15] || (_cache[15] = [_createElementVNode("img", {
    src: "/img/ajax-loader.gif"
  }, null, -1)]))], 512), [[_vShow, $data.loading]]), !$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_withDirectives(_createElementVNode("div", null, [_createElementVNode("h5", _hoisted_6, _toDisplayString($data.form.matter?.name), 1), _createElementVNode("h4", _hoisted_7, _toDisplayString($data.form.client?.name), 1)], 512), [[_vShow, !$data.pick && !$props.settlementContext]]), $data.pick ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_ClientMatterSearch, {
    cm: $data.cm,
    "query-filter": $data.cmQuery,
    horizontal: true,
    "client-only": !!$data.form.client?.billing?.billClient,
    "client-data-cy": "client-select",
    "matter-data-cy": "matter-select"
  }, null, 8, ["cm", "query-filter", "client-only"]), $data.form.client?.billing?.billClient ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[16] || (_cache[16] = [_createElementVNode("i", null, "Deposit is done at client level", -1)]))])) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_cache[17] || (_cache[17] = _createElementVNode("div", {
    class: "w-3/12"
  }, [_createElementVNode("label", {
    class: "py-2"
  }, " Trust Account ")], -1)), _createElementVNode("div", _hoisted_13, [_createVNode(_component_ll_select, {
    modelValue: $data.form.trust,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.trust = $event),
    items: _ctx.trusts,
    density: "compact",
    "item-title": "label",
    "item-value": "id",
    placeholder: "Select Trust Account",
    variant: "outlined",
    "hide-details": "true"
  }, null, 8, ["modelValue", "items"])])])], 512), [[_vShow, $options.showTrustAccount]])])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("span", null, " This will record a retainer paid by the client into the trust account ", 512), [[_vShow, !$options.firstDeposit]]), _withDirectives(_createElementVNode("span", _hoisted_14, [_cache[18] || (_cache[18] = _createElementVNode("span", {
    class: "fa fa-warning"
  }, null, -1)), _createTextVNode(" This is the first deposit for this " + _toDisplayString($data.form.matter ? $data.me?.terms.matter : "client") + " -- the necessary account", 1), _withDirectives(_createElementVNode("span", null, "s", 512), [[_vShow, !$data.form.client?.billing?.billClient]]), _cache[19] || (_cache[19] = _createTextVNode(" will be created in QuickBooks ", -1))], 512), [[_vShow, $options.firstDeposit]]), $options.firstDeposit && $options.trustAccountNameExceeds100 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[20] || (_cache[20] = [_createElementVNode("span", {
    class: "fa fa-warning"
  }, null, -1), _createTextVNode(" QuickBooks Online limits trust account names to 100 characters. This account will be created with a truncated name. ", -1)]))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_cache[21] || (_cache[21] = _createElementVNode("div", {
    class: "w-3/12"
  }, [_createElementVNode("label", {
    class: "py-2"
  }, " Payment Method ")], -1)), _createElementVNode("div", _hoisted_18, [_createVNode(_component_ll_select, {
    modelValue: $data.form.method,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.method = $event),
    items: $data.accountingMethods,
    "item-title": "name",
    "item-value": "value",
    placeholder: "Select Payment Method",
    variant: "outlined",
    density: "compact",
    "hide-details": "true",
    "return-object": "",
    "data-cy": "payment-method-select"
  }, null, 8, ["modelValue", "items"])])])]), _createElementVNode("div", _hoisted_19, [_cache[22] || (_cache[22] = _createElementVNode("div", {
    class: "w-3/12"
  }, [_createElementVNode("label", null, "Date")], -1)), _createElementVNode("div", _hoisted_20, [_createVNode(_component_ll_date_picker, {
    modelValue: $data.form.date,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.date = $event),
    label: "",
    "data-cy": "date-picker",
    showButton: false,
    "hide-details": true,
    "onValidation:error": $options.handleDateError
  }, null, 8, ["modelValue", "onValidation:error"])]), _cache[23] || (_cache[23] = _createElementVNode("div", {
    class: "w-2/12 text-right pr-3"
  }, [_createElementVNode("label", null, "Amount")], -1)), _createElementVNode("div", _hoisted_21, [_createElementVNode("input", {
    type: "text",
    class: "at-deposit-amount",
    style: {
      "height": "36px",
      "width": "100%",
      "box-sizing": "border-box"
    },
    value: $data.displayAmount,
    placeholder: "0.00",
    "data-cy": "deposit-amount",
    required: "",
    onInput: _cache[4] || (_cache[4] = (...args) => $options.onAmountInput && $options.onAmountInput(...args)),
    onBlur: _cache[5] || (_cache[5] = (...args) => $options.onAmountBlur && $options.onAmountBlur(...args)),
    onFocus: _cache[6] || (_cache[6] = (...args) => $options.onAmountFocus && $options.onAmountFocus(...args))
  }, null, 40, _hoisted_22)])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("label", _hoisted_25, [_cache[25] || (_cache[25] = _createTextVNode("From ", -1)), _createVNode(_component_LlTooltip, {
    icon: "help"
  }, {
    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode("Trust accounting rules require you to explicitly record the source of funds with all deposits", -1)]))]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_26, [_withDirectives(_createElementVNode("input", {
    type: "text",
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.form.source = $event),
    class: "span11 at-trust-amount-source"
  }, null, 512), [[_vModelText, $data.form.source]])])]), _createElementVNode("div", _hoisted_27, [_cache[26] || (_cache[26] = _createElementVNode("div", {
    class: "w-3/12"
  }, [_createElementVNode("label", {
    class: "py-2"
  }, "Use")], -1)), _createElementVNode("div", _hoisted_28, [_withDirectives(_createElementVNode("input", {
    type: "text",
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.form.description = $event),
    class: "trust-amount-use span11 focus:ring focus:ring-[rgba(var(--v-theme-primary),0.3)]"
  }, null, 512), [[_vModelText, $data.form.description]])])]), _createElementVNode("div", _hoisted_29, [_cache[27] || (_cache[27] = _createElementVNode("div", {
    class: "w-3/12"
  }, [_createElementVNode("label", {
    class: "py-2"
  }, "Memo")], -1)), _createElementVNode("div", _hoisted_30, [_withDirectives(_createElementVNode("textarea", {
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $options.memos = $event),
    rows: "2",
    disabled: "disabled"
  }, "              ", 512), [[_vModelText, $options.memos]])])]), _createElementVNode("div", _hoisted_31, [_createVNode(_component_LlSecondaryButton, {
    name: "reject",
    onClick: _cache[10] || (_cache[10] = $event => $options.cancel())
  }, {
    default: _withCtx(() => [...(_cache[28] || (_cache[28] = [_createTextVNode("Cancel", -1)]))]),
    _: 1
  }), _createElementVNode("div", null, [_createVNode(_component_LlSecondaryButton, {
    type: "submit",
    id: "record-deposit-button",
    color: "primary",
    disabled: $options.isSaveButtonDisabled,
    onClick: _cache[11] || (_cache[11] = _withModifiers($event => $options.save($data.form), ["prevent"]))
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("i", _hoisted_32, null, 512), [[_vShow, $data.saving]]), _cache[29] || (_cache[29] = _createElementVNode("span", null, "Record Deposit", -1))]),
    _: 1
  }, 8, ["disabled"])])])])) : _createCommentVNode("", true)])])], 512)), [[_vShow, $data.me]]);
}